import Link from "next/link";
import { useForm } from "react-hook-form";

import { Button } from "@/components/Buttons";
import {
  HiddenField,
  ReadOnlyField,
  SelectField,
  TextAreaField,
} from "@/components/Form/Parts/index";
import { inquiryList } from "@/lib/constants";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";

function createOption(value, format) {
  return { value: value, label: format };
}

function inquiryOptions() {
  const options = [];
  for (const key in inquiryList) {
    options.push(createOption(key, inquiryList[key]));
  }
  return options;
}

export default function Step2({
  onSubmit,
  pageBack,
  formData,
  user,
  privacypolicy,
  gip,
  ua,
}) {
  const { register, handleSubmit, formState } = useForm({
    defaultValues: formData,
  });
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <div className={processStyles.contentWrapper}>
        <div className={processStyles.content}>
          <p
            className={`${processStyles.contentHeader} ${processStyles.mailForm}`}
          >
            下記の内容をご確認のうえ「送信」ボタンを押してください。
          </p>
          <fieldset
            className={`${formStyles.basicFieldset} ${formStyles.marginOff}`}
          >
            <div className={formStyles.inputField}>
              <div className={formStyles.formGroup}>
                <ReadOnlyField
                  {...register("name")}
                  title={user ? "名前" : "名前（漢字、又はカナ）"}
                  value={formData?.fullName || user?.fullName}
                  required
                />
              </div>
            </div>
          </fieldset>
          <fieldset className={formStyles.basicFieldset}>
            <ReadOnlyField
              {...register("mailAddress")}
              value={formData?.mailAddress}
              title="ご連絡可能なEメールアドレス"
              required
            />
          </fieldset>
          <fieldset className={formStyles.basicFieldset}>
            <ReadOnlyField
              {...register("membersId")}
              value={formData?.membersId || user?.mailAddress || ""}
              title="スカパー！メンバーズID（ご登録の方のみ）"
            />
          </fieldset>
          <fieldset className={formStyles.basicFieldset}>
            <ReadOnlyField
              {...register("pastSpooxId")}
              value={formData?.pastSpooxId || ""}
              title="過去ご登録の旧SPOOX ID（ご登録の方のみ）"
            />
          </fieldset>
          <fieldset className={formStyles.basicFieldset}>
            <SelectField
              title="お問い合わせ内容"
              options={inquiryOptions()}
              name="commentOption"
              placeholder="お問い合わせ内容"
              value={createOption(
                formData?.commentOption,
                inquiryList[formData?.commentOption]
              )}
              isDisabled={true}
              required
            />
            <HiddenField
              {...register("commentOption")}
              defaultValue={formData?.commentOption}
            />
          </fieldset>
          <fieldset className={formStyles.basicFieldset}>
            <TextAreaField
              title="お問い合わせ内容の詳細"
              name="comment"
              placeholder="コメント"
              defaultValue={formData?.comment}
              readOnly
              required
              disabled
            />
            <HiddenField
              {...register("comment")}
              defaultValue={formData?.comment}
            />
            <HiddenField {...register("ua")} defaultValue={ua} />
            <HiddenField {...register("gip")} defaultValue={gip} />
          </fieldset>
        </div>
      </div>
      <div className={formStyles.guideArea}>
        <p>
          使用している端末（パソコン、スマートフォン、タブレット等）や、ご利用のネットワーク環境などの情報を添えて、お問い合わせの内容はできるだけ詳しくお書きください。
        </p>
        <ul>
          {privacypolicy && (
            <li>
              送信いただく前に、
              <Link
                href={privacypolicy.url}
                target="_blank"
                rel="noopener noreferrer"
                className={formStyles.textLink}
              >
                プライバシーポリシー
              </Link>
              の内容を必ずお読みください。またお客様本人が同意した上で個人情報をご入力ください。
            </li>
          )}
          <li>
            回答に時間がかかる場合がございます。また、お問い合わせ内容によってはご返信できない場合がございます。あらかじめご了承ください。
          </li>
          <li>
            日本語以外のお問い合わせにはお応えできませんので、ご了承ください。
            <br />
            Please understand that all information is provided in Japanese only.
          </li>
        </ul>
      </div>
      <div
        className={`${formStyles.btnArea} ${formStyles.multiple} ${formStyles.minWidth10em}`}
      >
        <Button type="button" onClick={pageBack} borderGray fontFixed>
          戻る
        </Button>
        <Button
          type="submit"
          fillColor
          fontFixed
          loading={formState.isSubmitting}
        >
          送信
        </Button>
      </div>
    </form>
  );
}
